<template>
  <div class="layout-root">
    <el-container class="layout">
      <el-aside :width="asideWidth" class="aside">
        <div class="logo">平台管理端</div>
        <el-menu
          :default-active="$route.path"
          :collapse="isCollapsed"
          :collapse-transition="false"
          router
          class="menu"
          background-color="#001529"
          text-color="#bfcbd9"
          active-text-color="#ffffff"
        >
          <el-menu-item index="/cabinet">
            <i class="el-icon-box"></i>
            <span slot="title">智能柜</span>
          </el-menu-item>
          <el-menu-item index="/org">
            <i class="el-icon-office-building"></i>
            <span slot="title">机构</span>
          </el-menu-item>
          <el-menu-item index="/user">
            <i class="el-icon-user"></i>
            <span slot="title">用户</span>
          </el-menu-item>
          <el-menu-item index="/log">
            <i class="el-icon-document"></i>
            <span slot="title">日志</span>
          </el-menu-item>
          <el-menu-item index="/open-log">
            <i class="el-icon-tickets"></i>
            <span slot="title">开门日志</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <div class="left">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>平台</el-breadcrumb-item>
              <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="right">
            <el-tooltip content="刷新当前页面" placement="bottom">
              <el-button type="text" icon="el-icon-refresh" @click="refresh" />
            </el-tooltip>

            <el-divider direction="vertical"></el-divider>

          <el-tooltip :content="isCollapsed ? '展开菜单' : '收起菜单'" placement="bottom">
            <el-button type="text" :icon="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="toggleCollapse" />
          </el-tooltip>

            <el-dropdown trigger="click">
              <span class="user">
                <i class="el-icon-user-solid"></i>
                {{ me ? (me.nickName || me.openid) : "加载中…" }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="goMe">我的信息</el-dropdown-item>
                <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-main class="main">
          <router-view v-loading="loadingMe" />
        </el-main>
      </el-container>
    </el-container>

    <el-dialog
      title="我的信息"
      :visible.sync="meDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="昵称">{{ (me && me.nickName) || "-" }}</el-descriptions-item>
        <el-descriptions-item label="openid">{{ (me && me.openid) || "-" }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ (me && me.phoneNumber) || "-" }}</el-descriptions-item>
      </el-descriptions>

      <div style="height: 14px;"></div>
      <el-divider content-position="left">修改密码</el-divider>

      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="90px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" autocomplete="current-password" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" autocomplete="new-password" show-password />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" autocomplete="new-password" show-password />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="meDialogVisible=false">关闭</el-button>
        <el-button type="primary" :loading="changingPwd" @click="submitChangePassword">保存密码</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { clearToken } from "@/utils/token";
import { getMe, adminChangePassword } from "@/api";

export default {
  name: "Layout",
  data() {
    return {
      me: null,
      loadingMe: false,
      isCollapsed: false,
      meDialogVisible: false,
      changingPwd: false,
      pwdForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      pwdRules: {
        oldPassword: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "新密码至少 6 位", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          {
            validator: (rule, value, cb) => {
              if (!value) return cb();
              if (value !== this.pwdForm.newPassword) return cb(new Error("两次输入的新密码不一致"));
              cb();
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    title() {
      const map = {
        "/cabinet": "智能柜",
        "/org": "机构",
        "/user": "用户",
        "/log": "日志",
        "/open-log": "开门日志"
      };
      return map[this.$route.path] || "页面";
    },
    asideWidth() {
      return this.isCollapsed ? "64px" : "200px";
    }
  },
  mounted() {
    this.loadMe();
    this.handleResize();
    window.addEventListener("resize", this.handleResize, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    meDialogVisible(v) {
      if (v) {
        // 打开时保证展示的是最新 me
        this.loadMe();
      } else {
        this.resetPwdForm();
      }
    }
  },
  methods: {
    async loadMe() {
      this.loadingMe = true;
      try {
        const res = await getMe();
        this.me = res && res.data;
      } catch (e) {
        // 401 会在拦截器里自动退出
      } finally {
        this.loadingMe = false;
      }
    },
    refresh() {
      // 触发子页面重新 mounted（保留当前 path）
      this.$router.go(0);
    },
    handleResize() {
      const w = window.innerWidth || 0;
      // 小屏自动折叠；大屏保持用户手动选择（仅在首次/从未手动操作时自动）
      if (w > 0 && w < 1100) {
        this.isCollapsed = true;
      }
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    goMe() {
      this.meDialogVisible = true;
    },
    logout() {
      clearToken();
      this.$router.replace("/login");
    },
    resetPwdForm() {
      this.pwdForm = { oldPassword: "", newPassword: "", confirmPassword: "" };
      if (this.$refs.pwdForm) this.$refs.pwdForm.clearValidate();
    },
    async submitChangePassword() {
      if (!this.$refs.pwdForm) return;
      try {
        await this.$refs.pwdForm.validate();
      } catch (e) {
        return;
      }

      this.changingPwd = true;
      try {
        await adminChangePassword({
          oldPassword: this.pwdForm.oldPassword,
          newPassword: this.pwdForm.newPassword
        });
        this.$message.success("密码已更新，请重新登录");
        this.meDialogVisible = false;
        this.resetPwdForm();
        this.logout();
      } catch (e) {
        this.$message.error("修改失败：原密码错误或服务不可达");
      } finally {
        this.changingPwd = false;
      }
    }
  }
};
</script>

<style scoped>
.layout-root {
  height: 100%;
}
.layout {
  height: 100%;
}
.aside {
  background: #001529;
}
.logo {
  height: 56px;
  line-height: 56px;
  color: #fff;
  font-weight: 600;
  padding: 0 16px;
}
.menu {
  border-right: 0;
}
.menu /deep/ .el-menu-item.is-active {
  background: rgba(255, 255, 255, 0.12) !important;
}
.menu /deep/ .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}
.header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}
.left {
  color: #606266;
}
.right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.user {
  cursor: pointer;
  color: #303133;
  user-select: none;
}
.main {
  padding: 16px;
  overflow: auto;
}
</style>

